import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import './App.css';
import Home from './Components/Home';
import About from "./Components/About";
import Footer from "./Components/Footer";
import Gallary from "./Components/Gallary";
import Contactus from "./Components/Contactus";

import Navbarss from "./Components/Navbarss";
import Admission from "./Components/Admission";
import Facillities from "./Components/Facillities";
function App() {
  return (
    <>
<div >

      <BrowserRouter>
      <Navbarss/>
        <Routes>
        
          <Route path="/" element={<Home />}/>
          <Route path="/about" element={<About />}/>
          <Route path="/gallery" element={<Gallary />}/>
          <Route path="/contactus" element={<Contactus />}/>
          <Route path="/admission" element={<Admission/>}/>
          <Route path="/facillities" element={<Facillities/>}/>
   

        </Routes>
<Footer></Footer>
    
      </BrowserRouter>

</div>


    </>



  );
}


export default App;
